import {Button, Typography} from '@mui/material';
import {useAuth} from '@saltus/auth';
import {useNavigate, useParams} from 'react-router-dom';
import React from 'react';
import MfaEnrolmentPanel from '../../components/Mfa/MfaEnrolmentPanel';
import TickIcon from '../../theme/styled-components/TickIcon';
import {themeColors} from '../../theme/Theme';

const classes = {
  button: {
    backgroundColor: themeColors.coral,
    border: `2px solid ${themeColors.coral}`,
    color: themeColors.white,
    fontWeight: 400,
    margin: 0,
    padding: '5px 60px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: themeColors.backgroundDark,
      border: `2px solid ${themeColors.backgroundDark}`,
    },
  },
  label: {
    margin: '16px 0',
  },
  strongText: {
    fontWeight: 600,
  },
};

function MfaEnrolledPage() {
  const {user} = useAuth();

  const navigate = useNavigate();
  const {pathway} = useParams();
  const getText = (app: string, sms: string) => (pathway === 'sms' ? sms : app);

  if (user) {
    return (
      <MfaEnrolmentPanel
        title="Two-factor authentication"
        subTitle={getText('Authenticator app', 'Text message')}
        button={
          <Button
            sx={classes.button}
            type="button"
            variant="outlined"
            onClick={() => {
              navigate('/');
            }}
          >
            Done
          </Button>
        }
        align="center"
      >
        <TickIcon
          style={{
            margin: '0 auto 16px',
          }}
          fill="#59D09E"
        />
        <Typography sx={classes.strongText} variant="body1">
          Successfully enabled
        </Typography>
        <Typography sx={classes.label} variant="body2">
          {getText(
            'Every time you log in, you will be prompted to enter a unique code generated by your authenticator app.',
            `Your phone number is set up as ${user.attributes.phone_number}. Authetication codes will be sent to this number.`
          )}
        </Typography>
        <Typography sx={classes.label} variant="body2">
          {getText('You can now continue.', 'You can now access the portal.')}
        </Typography>
      </MfaEnrolmentPanel>
    );
  }

  return null;
}

export default MfaEnrolledPage;
